import { Hero } from '../components/Hero';
import { MockupIntake } from '../components/MockupIntake';
import { MockupPick } from '../components/MockupPick';
import { MockupWrap } from '../components/MockupWrap';
import { MockupEarn } from '../components/MockupEarn';
import { MathStrip } from '../components/MathStrip';
import { Wedge } from '../components/Wedge';
import { PricingTeaser } from '../components/PricingTeaser';
import { CtaPanel } from '../components/CtaPanel';
import { MockupThread } from '../components/MockupThread';

export function Home() {
  return (
    <>
      <MockupThread />
      <main>
        <Hero />
        <MockupIntake />
        <MockupPick />
        <MockupWrap />
        <MockupEarn />
        <MathStrip />
        <Wedge />
        <PricingTeaser />
        <CtaPanel />
      </main>
    </>
  );
}
